module.exports = __webpack_public_path__ + "img/jksb.b3d74204.svg";